import { useTranslation } from 'react-i18next';

import { PageDetailContent } from '@client/toolkit';

import {
  AgreementConditionsCard,
  AgreementCommonCostsCard,
  AgreementNameField,
  AgreementProductsCard,
  AgreementSpacesCard,
} from '../components';

import { PageContentAnimation } from '../../../../components';
import { AgreementWizardActions } from '../components/agreement-wizard-actions.component';

export function AgreementDetailsRoute() {
  const { t: tGlobal } = useTranslation('global');
  return (
    <PageDetailContent>
      <PageContentAnimation className="space-y-4 px-4 pt-2 pb-8 rounded-lg shadow-lg border border-border">
        <div className="flex items-center">
          <AgreementNameField className="flex-1" />
          <AgreementWizardActions />
        </div>

        <AgreementConditionsCard />

        <AgreementSpacesCard />
        <AgreementCommonCostsCard />
        <AgreementProductsCard title={tGlobal('agreement.product', { context: 'plural' })} />
      </PageContentAnimation>
    </PageDetailContent>
  );
}
